import React, { useState } from 'react';
import { useIsDev } from '../../hooks/useIsDev';
import PageTitle from '../headers/PageTitle';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import MobileWarningDialog from '../DesignSystems/MobileWarning/MobileWarningDialog';
import { CloudUploadOutlined } from '@mui/icons-material';
import { useBulkCreateResources } from './hooks/bulkResourcesHooks';
import { toast } from 'react-toastify';
const IAPBulkResources: React.FC = () => {
  const [sitesFileToUpload, setSitesFileToUpload] = useState<
    File | undefined
  >();
  const [setsFileToUpload, setSetsFileToUpload] = useState<File | undefined>();

  const { mutate: bulkCreateResources } = useBulkCreateResources();

  const isDev = useIsDev();
  if (!isDev) {
    return (
      <div className="maincontent">
        <PageTitle title="Access Restricted">
          <p>This feature is available to developers only.</p>
        </PageTitle>
      </div>
    );
  }

  const onSitesFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files?.[0]) {
      const file = files[0];
      if (!file.name.endsWith('.csv')) {
        toast.error('Only CSV files are supported');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        // 10MB limit
        toast.error('File size must be less than 10MB');
        return;
      }
      setSitesFileToUpload(files[0]);
    }
  };

  const onSetsFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files?.[0]) {
      const file = files[0];
      if (!file.name.endsWith('.csv')) {
        toast.error('Only CSV files are supported');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        // 10MB limit
        toast.error('File size must be less than 10MB');
        return;
      }
      setSetsFileToUpload(files[0]);
    }
  };
  const handleSitesUploadClick = () => {
    if (sitesFileToUpload) {
      bulkCreateResources(sitesFileToUpload);
    }
  };

  const handleSetsUploadClick = () => {
    if (setsFileToUpload) {
      bulkCreateResources(setsFileToUpload);
    }
  };

  return (
    <MobileWarningDialog>
      <div className="maincontent">
        <PageTitle title="Bulk Resource Upload"></PageTitle>
        <>
          <h4>Rules</h4>
          <ul>
            <li>
              CSV files must be properly formatted according to the template
            </li>
            <li>Maximum file size: 10MB</li>
            <li>Upload sites before resources to establish dependencies</li>
            <li>Invalid rows will be skipped with error reporting</li>
          </ul>
          <h4>Import Process:</h4>
          <ol>
            <li>Download and fill out the CSV template</li>
            <li>Upload Resource Sites first</li>
            <li>Upload Resources second</li>
            <li>Review the results and fix any errors</li>
          </ol>
          <h4>1. Upload Resource Sites</h4>
          <div className="form-upload">
            <div>
              <span className="d-flex justify-content-center mb-2">
                <CloudUploadOutlined className="cloud-upload-icon" />
              </span>
              <span className="d-block">
                Drop Your Files Here or Click to Upload
              </span>
            </div>
            <input
              type="file"
              name="select-file-input"
              accept=".csv"
              onChange={onSitesFileChange}
            />
          </div>
          <div className="mb-3">
            Selected &ldquo;sites&rdquo; csv file:{' '}
            {sitesFileToUpload ? sitesFileToUpload.name : 'No file selected'}
          </div>
          <div className="mb-3">
            <StylishNewButton
              className="button--primary"
              onClick={handleSitesUploadClick}
              disabled={!sitesFileToUpload}
            >
              Bulk Create Resource Sites
            </StylishNewButton>
          </div>
          <h4>2. Upload Resources</h4>
          <div className="form-upload">
            <div>
              <span className="d-flex justify-content-center mb-2">
                <CloudUploadOutlined className="cloud-upload-icon" />
              </span>
              <span className="d-block">
                Drop Your Files Here or Click to Upload
              </span>
            </div>
            <input
              type="file"
              name="select-file-input"
              accept=".csv"
              onChange={onSetsFileChange}
            />
          </div>
          <div className="mb-3">
            Selected &ldquo;sets&rdquo; csv file:{' '}
            {setsFileToUpload ? setsFileToUpload.name : 'No file selected'}
          </div>
          <div className="mb-3">
            <StylishNewButton
              className="button--primary"
              onClick={handleSetsUploadClick}
              disabled={!setsFileToUpload}
            >
              Bulk Create Resources
            </StylishNewButton>
          </div>
        </>
      </div>
    </MobileWarningDialog>
  );
};
export default IAPBulkResources;
